var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.5,
    height: 17.388,
    viewBox: "0 0 16.5 17.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4198",
    "data-name": "Path 4198",
    d: "M5.256,14.82V12.4a1.126,1.126,0,0,1,1.124-1.12H8.658A1.126,1.126,0,0,1,9.79,12.4h0v2.429a.967.967,0,0,0,.949.962h1.519A2.728,2.728,0,0,0,15,13.075h0V6.188a1.926,1.926,0,0,0-.759-1.5L9.046.541a2.511,2.511,0,0,0-3.114,0L.759,4.691A1.911,1.911,0,0,0,0,6.2v6.88a2.728,2.728,0,0,0,2.742,2.714H4.261a.975.975,0,0,0,.98-.97h0",
    transform: "translate(0.75 0.848)",
    fill: "none",
    stroke: "#f6c244",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.4000339df437d740f8a146038ac18d2b.svg";
export { ForwardRef as ReactComponent };